<template >
  <div class="quiz-item card" v-show="show">
  	<div v-for="(questionObj, objIndex) in question.list" v-show="showQuestionObj(objIndex)">
	  	<h4 class="card-header">
	  		<img v-if="questionObj.featured" :src="'./static/images/featured/' + questionObj.featured + '.png'"/>
	  		{{questionObj.question}}
	  	</h4>
	  	<div class="options card-block">
	       <div v-for="option in questionObj.options">
		       <input type="radio" :id="option.image" :name="name" :value="option.image">
		       <label :for="option.image" class="btn btn-lg btn-primary btn-block" @click="selectAnswer(question, option)">
			       <span class="btn-label"><i class="fa fa-chevron-right" aria-hidden="true"></i></span>
			       {{option.option}}
		       </label>
	       </div>
	       <div class="paging">
				<i class="fa fa-chevron-left" :class="{active: showPrev}" @click="prevQuestion"></i>
				<span>{{index + 1}} / {{length}}</span>
				<i class="fa fa-chevron-right" :class="{active: showNext}" @click="nextQuestion"></i>
	       </div>
	    </div>
    </div>
  </div>
</template>

<script>
export default {
	name: 'quiz-item',
	props: ['question','index','selectedIndex','latest','length','binding'],
	data() {
		return {
			name: 'q-' + this.index
		}
	},
	methods: {
		selectAnswer(question, option) {
			// check for option binding attribute (determines the questionObj index of the next question)
			option.binding = ("undefined" !== typeof option.binding) ? option.binding : 0;
			
			// emit answer event
			this.$emit('answer', {
				"question": question,
				"image": option.image,
				"binding": option.binding
			})
		},
		prevQuestion() {
			if (this.showPrev) {
				this.$emit('prev')
			}
		},
		nextQuestion() {
			if (this.showNext) {
				this.$emit('next')
			}
		},
		showQuestionObj(index) {
			return index === this.binding
		}
	},
	computed: {
		show() {
			return this.index === this.selectedIndex
		},
		showPrev() {
			return this.index > 0
		},
		showNext() {
			return this.index < this.latest
		}
	}
}
</script>

<style scoped>
	h4 {
		font-weight: bold;
		overflow: hidden;
	}

	h4 img {
		display: block;
		height: 30px;
		margin: 0 auto 10px;
	}

	.options > div {
		position: relative;
	}

	.options input[type="radio"] {
		position: absolute;
	    clip: rect(0,0,0,0);
	    pointer-events: none;
	}

	.options .btn {
		padding-left: 2.5rem;
		margin: 12px 0;
		color: #fff;
	    background-color: #3a8cd2;
	    border-color: #357ebd;
	    cursor: pointer;
	    white-space: normal;
	}

	.options .btn:hover {
	    text-shadow: 0 3px 2px rgba(0,0,0,0.4);
	    -webkit-transform: scale(1.075);
	    -moz-transform: scale(1.075);
	    -o-transform: scale(1.075);
	    background-color: #2c6290;
	}

	.options input[type="radio"]:checked+.btn {
		-webkit-box-shadow: inset 0 3px 5px rgba(0,0,0,.125);
	    box-shadow: inset 0 3px 5px rgba(0,0,0,.125);
	    background-color: #2c6290;
	}

	.options .btn-label {
		position: absolute;
		left: 0;
		top: 0;
		display: inline-block;
		padding: 0 10px;
		background: rgba(0,0,0,.15);
		height: 100%;
	}

	.options .fa {
		line-height: 49px;
	}

	.paging .fa {
		padding: 0 10px;
		font-size: 22px;
		color: #ccc;
		cursor: pointer;
	}

	.paging .fa.active {
		color: #444;
	}

	.paging span {
		vertical-align: text-bottom;
	}

	@media (min-width: 440px) {
		.options .btn {
			padding-left: 1.5rem;
		}
	}

	@media (min-width: 560px) {
		h4 {
			line-height: 40px;
		}

		h4 img {
			float: left;
			height: 40px;
			margin: 0;
		}
	}
</style>


// WEBPACK FOOTER //
// QuizItem.vue?e2bb5ab4